import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const FormSubmissionEmailSentAuditItemDetails = ({ audit }) => (
  <div>
    <span>
      <AuditedUser audit={audit} /> {audit.comment}.
    </span>
  </div>
)

FormSubmissionEmailSentAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default FormSubmissionEmailSentAuditItemDetails
